// Core
import { useQuery } from 'react-query';
import { Box, Flex, Text } from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import { StarsIcon } from 'components/Icons/Icons';

const TerminationOfAccount = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['terminationOfAccount'],
    queryFn: async () => {
      const response = await apiService.getTerminationOfAccount();
      return response.data;
    },
    refetchOnWindowFocus: false,
  });

  return (
    <Box m={{ base: '-40px auto 100px auto', md: '37px auto 100px auto' }}>
      <Flex
        gap={{ base: '8px', md: '26px' }}
        m="82px 0 46px 0"
        w="100%"
        alignItems="center"
        textAlign="center"
        justifyContent="center"
      >
        <StarsIcon fontSize={{ base: '28px', md: '43px' }} />
        <Box
          bg="#099BFF"
          filter="blur(40px)"
          w="50%"
          h="40px"
          left="50%"
          borderRadius="full"
          transform="translate(-50%, 40px)"
          position="absolute"
          zIndex="-1"
        />
        <Text
          variant="header"
          fontSize={{ base: '46px', md: '64px', lg: '72px' }}
        >
          Termination of Account
        </Text>
        <StarsIcon fontSize={{ base: '28px', md: '43px' }} />
      </Flex>

      <Box maxW="744px" m="0px auto">
        {!isLoading && data && (
          <Box dangerouslySetInnerHTML={{ __html: data?.content?.html }} />
        )}
      </Box>
    </Box>
  );
};

export default TerminationOfAccount;
